/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=1e83089c"
import script from "./ModalWrapper.vue?vue&type=script&lang=js"
export * from "./ModalWrapper.vue?vue&type=script&lang=js"
import style0 from "./ModalWrapper.vue?vue&type=style&index=0&id=1e83089c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports